import Swiper from "swiper";

export default class VacationPlanSlider {
  constructor(elem, options = {}) {
    this.elem = $(elem);
    this.swiper = null;

    // Initialize swiper.
    const defaultOptions = {
      slidesPerView: "auto",
      loop: true,
      centeredSlides: true,
      spaceBetween: 0,
      navigation: {
        nextEl: this.elem.find(".swiper-button-next"),
        prevEl: this.elem.find(".swiper-button-prev")
      },
      pagination: {
        el: this.elem.find(".swiper-pagination"),
        type: "bullets"
      }
    };

    $(document).ready(() => {
      const options = Object.assign(defaultOptions, options);
      this.swiper = new Swiper(this.elem.find(".swiper-container"), options);
    });

    $(window).on("load", () => {
      if (!this.elem.find(".swiper-container").length) {
        return;
      }

      this.swiper.update();
    });
  }
}
